import { useCallback } from "react";
import { ColorCollectionsDraftApi, useAPIAction } from "melco-shared-logic";

export const useDeleteColorCollections = () => {
  const [deleteColorCollection] = useAPIAction(
    ColorCollectionsDraftApi,
    async (api, id: string) => {
      const data = await api.userColorCollectionsDelete({ id, force: true });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "color_collections.actions.delete",
    }
  );

  return useCallback(
    async (colorCollectionIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const colorCollectionId of colorCollectionIds) {
        try {
          await deleteColorCollection(colorCollectionId);
          successfullyDeleted.push(colorCollectionId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteColorCollection]
  );
};
